var _g, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocklinkDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 1388 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144828",
    style: {
      fill: "#fff"
    },
    d: "M0 0h54v52H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173051"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144827",
    transform: "translate(4 4)",
    style: {
      fill: "#f3f6fa",
      opacity: 0.004
    },
    d: "M0 0h46v44H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173050"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173049"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173059"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 92",
    d: "M27.531 23.572h-.018a3.242 3.242 0 0 1-2.287-.936 3.257 3.257 0 0 1 0-4.612l.814-.819.881.89-.809.815a2.006 2.006 0 0 0 1.423 3.425 1.988 1.988 0 0 0 1.422-.585l4.212-4.213a2.011 2.011 0 0 0-1.427-3.431 1.986 1.986 0 0 0-1.422.591l-.07.066-.887-.886.072-.071a3.261 3.261 0 0 1 4.619 4.6l-4.209 4.214a3.229 3.229 0 0 1-2.3.952z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 93",
    d: "M22.232 25.145a3.241 3.241 0 0 1-2.271-.919 3.252 3.252 0 0 1 0-4.616l4.205-4.209a3.265 3.265 0 0 1 4.619 4.616L27.6 21.203l-.889-.886 1.189-1.202a2.019 2.019 0 0 0 .59-1.427 1.984 1.984 0 0 0-.574-1.431 2 2 0 0 0-2.84 0l-4.213 4.209a2 2 0 0 0 0 2.84 2 2 0 0 0 2.84 0l.07-.07.887.891-.066.07a3.283 3.283 0 0 1-2.322.952z"
  })))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Link",
    transform: "translate(27 41)",
    style: {
      fill: "#252529",
      fontSize: 10,
      fontFamily: "NunitoSans-Regular,Nunito Sans"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -10.732,
    y: 0
  }, "Link"))))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144830",
    transform: "translate(0 51)",
    style: {
      fill: "#DDDFDD"
    },
    d: "M0 0h54v1H0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocklinkDefault);
export default __webpack_public_path__ + "static/media/BlocklinkDefault.6205d0f1a12a3f97d1dd8876925df3cc.svg";
export { ForwardRef as ReactComponent };